import { render } from "./TopbarTemplate.vue?vue&type=template&id=6fa66042"
import script from "./TopbarTemplate.vue?vue&type=script&lang=js"
export * from "./TopbarTemplate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__